import React, { createContext, useState } from 'react';

type Preference = {
    username: string | null;
};

interface PreferenceContextType {
    preference: Preference | null;
    update: (preferences: Preference) => void;
}

const PreferenceContext = createContext<PreferenceContextType | undefined>(undefined);

export function PreferenceProvider({ children }: { children: React.ReactNode }) {
    const [preference, setPreference] = useState<Preference>({
        username: localStorage.getItem('username'),
    });

    const update = (newPreferences: Preference) => {
        for (const key in newPreferences) {
            if (newPreferences[key as keyof Preference] === null) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key, String(newPreferences[key as keyof Preference]));
            }
        }
        setPreference((prev) => ({ ...prev, ...newPreferences }));
    };

    return <PreferenceContext.Provider value={{ preference, update }}>{children}</PreferenceContext.Provider>;
}

export const usePreference = (): PreferenceContextType => {
    const context = React.useContext(PreferenceContext);
    if (context === undefined) {
        throw new Error('usePreference must be used within a PreferenceProvider');
    }
    return context;
};
